import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'nominas/historico-permisos';

/**
 * GET Historicos Permisos
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getHistoricosPermisos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Historico Permiso
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getHistoricoPermiso = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Historico Permiso
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postHistoricoPermiso = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * PATCH Historico Permiso
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchHistoricoPermiso = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * DELETE Historico Permiso
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteHistoricoPermiso = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
  }
  return false;
};
